import { Icon, Text } from '@pairy/pds-react';

import useGetFirstVisit from '../../../../hooks/useGetFirstVisit';

import * as Styled from './index.styles';

interface MobileIntroProps {
  translateKoToEn: (item: string) => string;
}

const MobileIntro = ({ translateKoToEn }: MobileIntroProps) => {
  const [isPdfViewerFirstVisit, setIsPdfViewerFirstVisit] = useGetFirstVisit();

  const handleUserVisit = () => {
    setIsPdfViewerFirstVisit(false);
  };

  if (!isPdfViewerFirstVisit) {
    return null;
  }

  return (
    <Styled.FlexWrapper
      alignItems="center"
      justifyContent="center"
      onClick={handleUserVisit}
      onTouchStart={handleUserVisit}
    >
      <Styled.Wrapper>
        <Text variant="2xl-semibold" color="white">
          {translateKoToEn('initMessage-mobile-first')}
          <br />
          {translateKoToEn('initMessage-mobile-second')}
        </Text>

        <Styled.HandAnimation>
          <Icon icon="ph:hand-pointing" size={48} color="white" />
        </Styled.HandAnimation>
      </Styled.Wrapper>
      <Styled.DescriptionWrapper>
        <Text variant="md-semibold" color="white">
          {translateKoToEn('initMessage-mobile-third')}
        </Text>
      </Styled.DescriptionWrapper>
    </Styled.FlexWrapper>
  );
};

export default MobileIntro;
